export default __webpack_public_path__ + "static/gmx-logo-circle-ab8ef770d6b628bdbde6fc740dd3dee7.png";